import { Shimmer, ShimmerElementType } from "@fluentui/react";
import { contactListShimmerStyles as styles } from "./ContactListShimmer.styles";

export default function ContactListShimmer() {
  return (
    <>
      <Shimmer
        className={styles.shimmer1}
        shimmerElements={[{ type: ShimmerElementType.line, height: 10 }]}
        shimmerColors={{ shimmer: "rgb(222, 236, 249)" }}
      />
      <div className={styles.shimmerDiv}>
        <Shimmer
          className={styles.shimmer2}
          shimmerElements={[{ type: ShimmerElementType.circle, height: 50 }]}
          shimmerColors={{ shimmer: "rgb(222, 236, 249)" }}
        />
        <div>
          <Shimmer
            className={styles.shimmer3}
            shimmerElements={[{ type: ShimmerElementType.line, height: 10 }]}
            shimmerColors={{ shimmer: "rgb(222, 236, 249)" }}
          />
          <Shimmer
            className={styles.shimmer4}
            shimmerElements={[{ type: ShimmerElementType.line, height: 8 }]}
            shimmerColors={{ shimmer: "rgb(222, 236, 249)" }}
          />
        </div>
      </div>
    </>
  );
}
